import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { KomitentObjekat } from './komitent-objekat';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-komitent-objekat-modal-update',
  templateUrl: './komitent-objekat-modal-update.component.html'
})
export class KomitentObjekatModalUpdateComponent extends BaseModalUpdateComponent<KomitentObjekat> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<KomitentObjekat>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
